(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["puja-notice-popup"]) return;
  try {
    
  (() => {
    if (customElements.get('ho-puja-notice')) return;
    const selectedSections = new Set();

    class HoPujaNotice extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.editor = Boolean(window.Shopify && window.Shopify.designMode);
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.querySelectorAll('[data-ho-puja-close]').forEach(button => {
          button.addEventListener('click', () => this.close(true), options);
        });
        this.dialog.addEventListener('cancel', event => {
          event.preventDefault();
          this.close(true);
        }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right ||
              event.clientY < rect.top || event.clientY > rect.bottom) this.close(true);
        }, options);
        this.dialog.addEventListener('close', () => this.restoreScroll(), options);
        document.addEventListener('shopify:section:select', event => {
          if (String(event.detail.sectionId) !== this.dataset.sectionId) return;
          selectedSections.add(this.dataset.sectionId);
          this.schedule(true);
        }, options);
        document.addEventListener('shopify:section:deselect', event => {
          if (String(event.detail.sectionId) !== this.dataset.sectionId) return;
          selectedSections.delete(this.dataset.sectionId);
          this.close(false);
        }, options);
        this.schedule(this.editor && selectedSections.has(this.dataset.sectionId));
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.expiryTimer);
        this.close(false);
        if (this.controller) this.controller.abort();
      }

      schedule(preview) {
        clearTimeout(this.timer);
        if (this.dataset.enabled !== 'true') return;
        if (this.editor) {
          if (preview && this.dataset.preview === 'true') this.open(true);
          return;
        }
        if (!this.inWindow() || this.dismissed()) return;
        this.timer = setTimeout(() => {
          if (this.isConnected && this.inWindow() && !this.dismissed()) this.open(false);
        }, Number(this.dataset.delay) * 1000);
      }

      inWindow() {
        if (this.dataset.scheduled !== 'true') return true;
        const start = Date.parse(this.dataset.start);
        const end = Date.parse(this.dataset.end);
        const now = Date.now();
        // Invalid or reversed schedules stay hidden instead of becoming permanent.
        return Number.isFinite(start) && Number.isFinite(end) && start < end && now >= start && now < end;
      }

      storageKey() {
        // Changed notice text or schedule should be shown again to returning visitors.
        const content = [this.dataset.start, this.dataset.end, this.dataset.frequency, this.dialog.textContent].join('|');
        let hash = 0;
        for (let i = 0; i < content.length; i++) hash = ((hash << 5) - hash + content.charCodeAt(i)) | 0;
        return 'ho-puja-notice:' + this.dataset.sectionId + ':' + hash;
      }

      dismissed() {
        if (this.dataset.frequency === 'always') return false;
        try {
          const storage = this.dataset.frequency === 'session' ? window.sessionStorage : window.localStorage;
          const saved = storage.getItem(this.storageKey());
          if (!saved) return false;
          if (this.dataset.frequency === 'session') return true;
          const timestamp = Number(saved);
          return Number.isFinite(timestamp) && Date.now() >= timestamp && Date.now() - timestamp < 86400000;
        } catch (_) { return false; }
      }

      rememberDismissal() {
        if (this.editor || this.dataset.frequency === 'always') return;
        try {
          const storage = this.dataset.frequency === 'session' ? window.sessionStorage : window.localStorage;
          storage.setItem(this.storageKey(), String(Date.now()));
        } catch (_) { /* Notice remains usable when browser storage is unavailable. */ }
      }

      open(preview) {
        if (this.dialog.open) return;
        this.previousFocus = document.activeElement;
        this.dialog.showModal();
        this.scrollBefore = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.scrollLocked = true;
        this.dialog.querySelector('[data-ho-puja-close]').focus({ preventScroll: true });
        if (!preview && this.dataset.scheduled === 'true') {
          const remaining = Date.parse(this.dataset.end) - Date.now();
          this.expiryTimer = setTimeout(() => this.close(false), Math.min(remaining, 2147483647));
        }
      }

      restoreScroll() {
        if (!this.scrollLocked) return;
        // Preserve a newer scroll lock if another component took over in the meantime.
        if (document.documentElement.style.overflow === 'hidden') {
          document.documentElement.style.overflow = this.scrollBefore;
        }
        this.scrollLocked = false;
      }

      close(remember) {
        clearTimeout(this.timer);
        clearTimeout(this.expiryTimer);
        if (!this.dialog || !this.dialog.open) { this.restoreScroll(); return; }
        if (remember) this.rememberDismissal();
        this.dialog.close();
        this.restoreScroll();
        if (this.previousFocus && this.previousFocus.isConnected && typeof this.previousFocus.focus === 'function') {
          this.previousFocus.focus({ preventScroll: true });
        }
      }
    }
    customElements.define('ho-puja-notice', HoPujaNotice);
  })();

  } catch(e) { console.error(e); }
})();
})();
